module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-800-0569d3f71636385f3b812dbe0df85d6d.webp";